/* @generated from adl module ferovinum.sourcecontracts.organisationstoragelocationaccess */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.organisation_storage_location_access` contract.
 */
export interface OrganisationStorageLocationAccessSource {
  id: common_db.DbKey<ferovinum_app_db.OrganisationStorageLocationAccess>;
  organisationId: ferovinum_app_db.OrganisationId;
  storageLocationId: ferovinum_app_db.StorageLocationId;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeOrganisationStorageLocationAccessSource(
  input: {
    id: common_db.DbKey<ferovinum_app_db.OrganisationStorageLocationAccess>,
    organisationId: ferovinum_app_db.OrganisationId,
    storageLocationId: ferovinum_app_db.StorageLocationId,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): OrganisationStorageLocationAccessSource {
  return {
    id: input.id,
    organisationId: input.organisationId,
    storageLocationId: input.storageLocationId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const OrganisationStorageLocationAccessSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.organisationstoragelocationaccess","decl":{"annotations":[{"value":{"modelName":"source__app_db.organisation_storage_location_access","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.organisation_storage_location_access` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationStorageLocationAccess"}},"parameters":[]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"OrganisationStorageLocationAccessSource","version":{"kind":"nothing"}}};

export const snOrganisationStorageLocationAccessSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.organisationstoragelocationaccess", name:"OrganisationStorageLocationAccessSource"};

export function texprOrganisationStorageLocationAccessSource(): ADL.ATypeExpr<OrganisationStorageLocationAccessSource> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationStorageLocationAccessSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.organisationstoragelocationaccess.OrganisationStorageLocationAccessSource" : OrganisationStorageLocationAccessSource_AST
};
